import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { copyOf2ng0t8oizk6it as copyOf } from './_ArraysJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function arrayOfUninitializedElements(capacity) {
  // Inline function 'kotlin.require' call
  if (!(capacity >= 0)) {
    var message = 'capacity must be non-negative.';
    throw IllegalArgumentException().s2(toString(message));
  }
  // Inline function 'kotlin.arrayOfNulls' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return Array(capacity);
}
function resetRange(_this__u8e3s4, fromIndex, toIndex) {
  // Inline function 'kotlin.js.nativeFill' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.fill(null, fromIndex, toIndex);
}
function copyOfUninitializedElements(_this__u8e3s4, newSize) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return copyOf(_this__u8e3s4, newSize);
}
function resetAt(_this__u8e3s4, index) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4[index] = null;
}
//region block: exports
export {
  arrayOfUninitializedElements as arrayOfUninitializedElementsg6b068zrcm8j,
  copyOfUninitializedElements as copyOfUninitializedElements3uqjltwtgc0ej,
  resetAt as resetAt1d0jjdeh7nn7m,
  resetRange as resetRangeiqi6axdujnmn,
};
//endregion

//# sourceMappingURL=ArrayFunctions.mjs.map
